module.exports = __webpack_public_path__ + "static/media/dcdb-papa-hero-mobile.c2ad8abe.jpg";